import React, { useEffect, useState } from 'react'
import ShipDateDropdown from '../../sharedComponents/ShipDateDropdown'
import OrderSummaryTable from '../../sharedComponents/OrderSummaryTable'
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import IconButton from '@mui/material/IconButton';
import useCollectMoney from './useCollectMoney';
import { AgGridReact } from 'ag-grid-react';
import { toast } from 'react-toastify';
import useManageOrder from '../order/useManageOrder';
import CircularProgress from '@mui/material/CircularProgress';


const CollectMoney = () => {

  const IconComponent = (params) => {
    return <>
      <IconButton onClick={() => setSmileNameSelected(params.data.smileName)}>
        <DoubleArrowIcon style={{ color: 'blue' }}/>
      </IconButton>
    </>
  }

  const [rowData, setRowData] = useState([]);
  const [totalRowData, setTotalRowData] = useState([]);
  const [preRowData, setPreRowData] = useState([]);
  const [contactQuery, setContactQuery] = useState('');
  const [shipDateId, setShipDateId] = useState(null)
  const [smileNameSelected, setSmileNameSelected] = useState('')
  const [showTotal, setShowTotal] = useState(false)
  const {isLoading, getCustomersByShipDateId} = useCollectMoney()
  const [columnDefs, setColumnDefs] = useState([
    { headerName: 'Contact', field: 'contact', flex: 2 },
    { headerName: 'Phone', field: 'phone', flex: 1 },
    { field: 'action', cellRenderer: IconComponent, flex : 1}
  ]);

  const { orders, setOrders, getOrdersFromSmileName, collectInformCustomer} = useManageOrder()

  const onCellClicked = (params) => {
    if (params && params.value) {
      navigator.clipboard.writeText(params.value).then(() => {
        toast.success(`${params.value} Copied!!`,{autoClose: 500})
      }).catch(err => {
        console.error('Failed to copy text: ', err);
      })
    }
  };

  const gridOptions = {
    onCellClicked: onCellClicked
  };

  const getFilteredRowData = () => {
    if (!contactQuery) return rowData; // No query, return all row data
    return rowData.filter(record => record.contact.toLowerCase().includes(contactQuery.toLowerCase()));
  };

  const handleSelectChange = async (e) => {
    const response = await getCustomersByShipDateId({shipDateId: e.target.value})
    setPreRowData(response)
    setShowTotal(false)
    setShipDateId(e.target.value)
  }

  const handleArrivalListClicked = async () => {
    if(showTotal){
      setShowTotal(false);
      const response = await getCustomersByShipDateId({shipDateId})
      setPreRowData(response)
      setColumnDefs([
        { headerName: 'Contact', field: 'contact', flex: 2 },
        { headerName: 'Phone', field: 'phone', flex: 1 },
        { field: 'action', cellRenderer: IconComponent, flex: 1 }
      ]);
    }
  };

  const handleInform = async () => {
    try {
      const result = await collectInformCustomer({ smileName: smileNameSelected, collectShipDateId: shipDateId });
      if (result === true) {
        let updatedRowData = [];
  
        if (!showTotal) {
          updatedRowData = rowData.filter(record => record.smileName !== smileNameSelected);
        } else {
          // When showing total, update the specific records to mark them as informed without removing them from the view
          updatedRowData = rowData.map(record => {
            if (record.smileName === smileNameSelected) {
              return { ...record, isCollectInform: true }; // Assuming you have a flag like isCollectInform to mark as informed
            }
            return record;
          });
        }
        setRowData(updatedRowData);
      } else {
        // Handle cases where result might not be true, maybe due to an error or different response
        console.error("The operation to inform the customer was not successful.");
      }
    } catch (error) {
      console.error("Error informing customer: ", error);
      // Handle the error accordingly, maybe set an error state or show a notification
    }
  };
  

  const handleTotalClicked = async () => {
    if(!showTotal){
      setShowTotal(true);
      const response = await getCustomersByShipDateId({shipDateId})
      setPreRowData(response)
      setColumnDefs([
        { headerName: 'Contact', field: 'contact', flex: 2 },
        { headerName: 'Phone', field: 'phone', flex: 1 },
        { headerName: 'แจ้งลูกค้าแล้ว', field: 'isCollectInform', flex: 1 },
        { field: 'action', cellRenderer: IconComponent, flex: 1 }
      ]);
      }
  };

  useEffect(() => {
    if(preRowData){
      const formattedRecords = preRowData.map(record => ({
        ...record, // spread the other properties of the order
        phone: record.phone, 
        contact : record.contact,
        isCollectInform : record.isCollectInform
      }));
      setTotalRowData(formattedRecords);
      //always default with task only need to do 
      console.log(formattedRecords)
      console.log(showTotal)
      if(!showTotal){
        const filteredRecords = formattedRecords.filter(record => 
          record.isCollectInform == false)
        setRowData(filteredRecords)
        console.log(filteredRecords)
      }else{
        setRowData(formattedRecords)
      }
    }

  }, [preRowData])

  useEffect(() => {
    // Define an async function inside the useEffect
    const fetchData = async () => {
      //console.log(shipDateId)
      if (smileNameSelected) {
        const response = await getOrdersFromSmileName({ smileName: smileNameSelected, collectShipDateId: shipDateId });
      }
    };
  
    // Call the async function
    fetchData();
  }, [smileNameSelected]); 
  

  return (
    <div className="ag-theme-alpine mx-auto" style={{ width: '100%' }}>
      <h2>Collect Money</h2>
      <div className='grid grid-cols-6 gap-x-5'>
        <div className='col-span-2 pr-5 border-r border-gray-500'>
          <ShipDateDropdown 
            handleDataChange={handleSelectChange}
            includeDefault={true}
          />
          {isLoading && <CircularProgress />} {/* Render spinner when loading */}
          <br/>
          <div className='flex mt-3'>
            <button 
              className={`text-base font-bold btn ${!showTotal ? 'bg-blue-500 text-white' : 'bg-gray-300 text-gray-500'} w-32 cursor-pointer hover:bg-blue-400 hover:text-white`}
              onClick={handleArrivalListClicked}
              style={{ transition: 'all 0.3s ease' }}>
              รายการรอแจ้ง
            </button>
            <button 
              className={`text-base font-bold btn ${showTotal ? 'bg-blue-500 text-white' : 'bg-gray-300 text-gray-500'} w-32 cursor-pointer hover:bg-blue-400 hover:text-white`}
              onClick={handleTotalClicked}
              style={{ transition: 'all 0.3s ease' }}>
              รายการทั้งหมด
            </button>
          </div>
          <input
            type="text"
            placeholder="Search by Contact..."
            value={contactQuery}
            onChange={(e)=>setContactQuery(e.target.value)}
            className="input text-base w-full px-3 py-2 border border-gray-400 rounded-lg"
          />
          <div style={{ height: "75vh"}}>
            <AgGridReact
              gridOptions={gridOptions}
              columnDefs={columnDefs}
              rowData={getFilteredRowData()}
              defaultColDef={{ resizable: true }}
            />
          </div>
        </div>
        <div className='col-span-4'>
          <div className='flex'>
            {orders.length > 0 && <button onClick={handleInform} className='btn-primary ml-auto mb-2'>เก็บเงินแล้ว</button>}
          </div>
          <OrderSummaryTable orders={orders}/>
        </div>
      </div>
    </div>
  )
}

export default CollectMoney